import script from "./HasBeeTemplates.vue?vue&type=script&lang=js"
export * from "./HasBeeTemplates.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__